import VenoBox from 'venobox'

export default function() {

    console.info('popup');
    new VenoBox({
        selector: '[data-js="video-popup"]',
    });

	let inlinePopup = new VenoBox({
		selector: '.inline-popup',
		customClass: 'twk-inline-popup',
		numeration: false,
		infinigall: false,
		share: false,
		spinner: 'pulse',
		bgcolor: 'white',
		overlayColor: 'rgb(0 39 86 / 50%)',

		// onPostOpen: function(obj, gallIndex, thenext, theprev){
		// 	document.querySelector( '.twk-inline-popup .vbox-close' ).style.display = 'none'

		// 	document.querySelector( '.vbox-content .custom-close-button' ).addEventListener('click', function(){
		// 		inlinePopup.close()
		// 	}, false)
		// },
	});
}